module.exports = {
  announcement: { ...require('./announcement.utils') },
  feeService: { ...require('./feeService.utils') },
  common: { ...require('./common.utils') },
};
